import {
  getExternalCalendarEvent as _getExternalCalendarEvent,
  GetExternalCalendarEventPayload,
} from '@griply/services';
import { CalendarEventDetails } from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';
import { externalCalendarSanitizer } from './helpers/external-calendar-sanitizer';
import { reportUnknownCalendarEventError } from './helpers/report-unknown-calendar-event-error';

export const getExternalCalendarEvent = async (
  payload: GetExternalCalendarEventPayload,
): Promise<CalendarEventDetails | null> => {
  try {
    return await _getExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
      sanitizeDetails: externalCalendarSanitizer.sanitizeDetails,
    });
  } catch (error: unknown) {
    reportUnknownCalendarEventError(error, 'external-calendars-get-event');
    throw error;
  }
};
